import { Component, OnInit, Input } from '@angular/core';
import { FriendService } from '@services/friend.service';
import { GlobalService } from '@common/global';
import { NgxSmartModalService } from 'ngx-smart-modal';
import * as _ from 'lodash';
@Component({
  selector: 'app-dfriendprofile',
  templateUrl: './dfriendprofile.component.html',
  styleUrls: ['./dfriendprofile.component.sass']
})
export class DfriendprofileComponent implements OnInit {
  @Input('member') member: object;
  @Input('friend') friend: object;
  component="m";
  btn_process=false;
  constructor( public ngxSmartModalService: NgxSmartModalService,private _friend: FriendService, private _global: GlobalService) { }

  ngOnInit(): void {
  
  }
  ngOnChanges() {
    this.btn_process=false;
  }
  action(action){
    this.btn_process=true;
    let p = {
      application: 'member',
      component: this.component,
      friendId: this.member['id']
    };
    this._friend.action(p,action).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this._global.showMessage({ "type": 'success', "message":this._global.getVal(data, 'message.info', '')  });
          this.ngxSmartModalService.getModal('dfriendprofile').close();
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

}
